
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import Utils from "@/utilities/Utils";
    import ApiClient from "@/utilities/ApiClient";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import { Site } from "@/model/Site";
    import { IClientLookup } from "@/model/Client";
    import { ISaveResponse } from "@/model/ISaveResponse";

    @Component({ components: { ApiButton } })
    export default class SiteAddDialogue extends Vue {

        @Ref("siteForm") private readonly siteForm!: VForm;

        @Prop({ required: true }) clientList!: Array<IClientLookup>;

        showDialogue: boolean = false;

        site: Site = new Site();

        //
        // -- methods
        //

        async show(): Promise<void> {
            this.showDialogue = true;
        }

        validateClientID(value: string|null|undefined): boolean|string {
            if (Utils.isEmptyId(this.site.clientID)) return "Please choose a client";
            return true;
        }

        async addSite(): Promise<void> {

            if (!(this.siteForm?.validate() ?? true)) {
                toastr.warning("Please fix highlighted issues", "Cannot Add Site");
                return;
            }

            const response: ISaveResponse = await ApiClient.post("/api/site/save", this.site, "site-save");
            if(this.site.isNew) this.site.id = response.newID;

            if(response.isSuccess) {
                toastr.success("Added");
                this.$emit("added", response.newID);
                this.showDialogue = false;
            }
            else {
                toastr.error(response.message, "Failed");
            }
        }
    }
